import { T } from "@tolgee/react";
import { FC } from "react";

interface BomPageExplainerSectionTitleProps {
  title: string;
}

export const BomPageExplainerSectionTitle: FC<
  BomPageExplainerSectionTitleProps
> = ({ title }) => {
  return (
    <div className="text-sm font-medium text-gray-800">
      <T keyName={title} />
    </div>
  );
};
